import React from 'react';
import { Checkbox } from './Checkbox';

export const renderCheckbox = ({
  input,
  meta: { touched, error },
  handleChange,
  children,
  colorActive,
  className,
  isDisabled
}) => (
  <Checkbox
    {...input}
    name={input.name}
    handleChangeInput={input.onChange}
    handleChange={handleChange}
    handleBlur={input.onBlur}
    error={touched && error}
    checked={input.value}
    children={children}
    colorActive={colorActive}
    className={className}
    disabled={isDisabled}
  />
);
